<style scoped>
li.c-sidebar-nav-item.active {
  background-color: rgb(33, 49, 76) !important;
}
</style>
<template>
  <CSidebar
    fixed
    style="background:#1a3665"
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none bg-white" to="/">
      <img src="/img/iapi-logo.jpg" alt="brand" srcset class="img img-fluid img-responsive" />
    </CSidebarBrand>
    <ul class="c-sidebar-nav">
      <li class="c-sidebar-nav-item">
        <a class="c-sidebar-nav-link" href="#/dashboard">
          <i class="c-sidebar-nav-icon fas fa-tachometer-alt"></i> {{ this.$string.dashboard }}
        </a>
      </li>
      <li class="c-sidebar-nav-dropdown" v-bind:class="[datamaster ? 'c-show' : '']" v-show="cekRole('ROLE_MENU_MASTER')">
        <a class="c-sidebar-nav-dropdown-toggle c-brand-minimizer" @click="toggleDatamaster" >
          <i class="c-sidebar-nav-icon fas fa-database"></i>
          {{ this.$string.sidebar.menu_1.text }}
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_INFORMASI_UMUM')">
            <a href="#/data-master/informasi-umum" class="c-sidebar-nav-link" target="_self" >
              <i class="c-sidebar-nav-icon cil-speedometer"></i>
              {{ this.$string.sidebar.menu_1.sub_menu.menu_1 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_ARTIKEL')">
            <a href="#/data-master/artikel" class="c-sidebar-nav-link" target="_self" >
              <i class="c-sidebar-nav-icon cil-speedometer"></i>
              {{ this.$string.sidebar.menu_1.sub_menu.menu_11 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_DIVISI')">
            <a 
              href="#/data-master/divisi" 
              class="c-sidebar-nav-link" 
              target="_self">
              {{ this.$string.sidebar.menu_1.sub_menu.menu_2 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_LEVEL')">
            <a 
              href="#/data-master/tingkatan" 
              class="c-sidebar-nav-link" 
              target="_self">
              {{ this.$string.sidebar.menu_1.sub_menu.menu_3 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_TEST_CENTER')">
            <a
              href="#/data-master/data-test-center"
              class="c-sidebar-nav-link"
              target="_self"
            >
            {{ this.$string.sidebar.menu_1.sub_menu.menu_4 }}
          </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_MASTER_JADWAL_TC')">
            <a
              href="#/data-master/jadwal-test-center"
              class="c-sidebar-nav-link"
              target="_self"
            >
            {{ this.$string.sidebar.menu_3.sub_menu.menu_4 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_CABANG')">
            <a 
              href="#/data-master/cabang" 
              class="c-sidebar-nav-link" 
              target="_self">
              {{ this.$string.sidebar.menu_1.sub_menu.menu_5 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PERIODE')">
            <a 
              href="#/data-master/master-periode" 
              class="c-sidebar-nav-link" 
              target="_self">
              {{ this.$string.sidebar.menu_1.sub_menu.menu_9 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_KUPON')">
            <a 
              href="#/data-master/kupon" 
              class="c-sidebar-nav-link" 
              target="_self">
              {{ this.$string.sidebar.menu_1.sub_menu.menu_6 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_MASTER_LOKASI')">
            <a
              href="#/data-master/master-lokasi"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_1.sub_menu.menu_7 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_DOKUMEN')">
            <a 
              href="#/data-master/dokumen" 
              class="c-sidebar-nav-link" 
              target="_self">
              {{ this.$string.sidebar.menu_1.sub_menu.menu_8 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_KARIR')">
            <a 
              href="#/data-master/karir" 
              class="c-sidebar-nav-link" 
              target="_self">
              {{ this.$string.sidebar.menu_1.sub_menu.menu_10 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_MASTER_MATA_UJI')">
            <a href="#/sertifikasi/master-mata-uji" class="c-sidebar-nav-link" target="_self">
              <i class="c-sidebar-nav-icon cil-speedometer"></i>
              {{ this.$string.sidebar.menu_3.sub_menu.menu_2 }}
            </a>
          </li>
          
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_MATA_KULIAH')">
            <a href="#/data-master/master-mata-kuliah" class="c-sidebar-nav-link" target="_self">
              <i class="c-sidebar-nav-icon cil-speedometer"></i>
              {{ this.$string.sidebar.menu_1.sub_menu.menu_13 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PAKTA_INTEGRITAS')">
            <a href="#/data-master/pakta-integritas" class="c-sidebar-nav-link" target="_self">
              <i class="c-sidebar-nav-icon cil-speedometer"></i>
              {{ this.$string.sidebar.menu_1.sub_menu.menu_12 }}
            </a>
          </li>
          
        </ul>
      </li>
      <li class="c-sidebar-nav-dropdown" v-bind:class="[usermanajemen ? 'c-show' : '']" v-show="cekRole('ROLE_MENU_USER_MANAJEMEN')">
        <a class="c-sidebar-nav-dropdown-toggle c-brand-minimizer" @click="toggleUserManajemen">
          <i class="c-sidebar-nav-icon fas fa-user-cog"></i>
          {{ this.$string.sidebar.menu_2.text }}
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PETUGAS_IAPI')">
            <a href="#/user-manajemen/petugas-aktif" class="c-sidebar-nav-link" target="_self">
              <i class="c-sidebar-nav-icon cil-speedometer"></i>
              {{ this.$string.sidebar.menu_2.sub_menu.menu_1 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PETUGAS_LMS')">
            <a href="#/user-manajemen/petugas-lms-aktif" class="c-sidebar-nav-link" target="_self">
              <i class="c-sidebar-nav-icon cil-speedometer"></i>
              Petugas LMS
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PETUGAS_TEST_CENTER')">
            <a
              href="#/user-manajemen/petugas-tc-aktif"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_2.sub_menu.menu_2 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item"  v-show="cekRole('ROLE_PETUGAS_BANK_SOAL')">
            <a
              href="#/user-manajemen/petugas-grader-aktif"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_2.sub_menu.menu_3 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PETUGAS_GRADER')">
            <a
              href="#/user-manajemen/user-grader-aktif"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_2.sub_menu.menu_4 }}
            </a>
          </li>
        </ul>
      </li>
      <li class="c-sidebar-nav-dropdown" v-bind:class="[sertifikasi ? 'c-show' : '']" v-show="cekRole('ROLE_MENU_SERTIFIKASI')">
        <a class="c-sidebar-nav-dropdown-toggle c-brand-minimizer" @click="toggleSertifikasi">
          <i class="c-sidebar-nav-icon fas fa-file-alt"></i>
          {{ this.$string.sidebar.menu_3.text }}
        </a>
        
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_MASTER_SERTIFIKASI')">
            <a
              href="#/sertifikasi/master-sertifikasi"
              class="c-sidebar-nav-link"
              target="_self">
            {{ this.$string.sidebar.menu_3.sub_menu.menu_1 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_DATA_PESERTA_SERTIFIKASI')">
            <a
              href="#/sertifikasi/data-peserta"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_3.sub_menu.menu_5 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PENGAJUAN_SERTIFIKASI')">
            <a
              href="#/sertifikasi/pengajuan-sertifikat"
              class="c-sidebar-nav-link"
              target="_self"
            >
            {{ this.$string.sidebar.menu_3.sub_menu.menu_6 }}
            </a>
          </li>
        
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_RIWAYAT_PESERTA')">
            <a
              href="#/sertifikasi/riwayat-peserta"

              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_3.sub_menu.menu_8 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item">
            <a
              
              href="#/sertifikasi/pengajuan-ujian"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_3.sub_menu.menu_9 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item">
            <a
              
              href="#/sertifikasi/pengajuan-dasar"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_3.sub_menu.menu_10 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item">
            <a
              
              href="#/sertifikasi/pengajuan-Professional"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_3.sub_menu.menu_11 }}
            </a>
          </li>
           <li class="c-sidebar-nav-item">
            <a
              
              href="#/sertifikasi/pengajuan-Lanjutan"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_3.sub_menu.menu_12 }}
            </a>
          </li>
        
        </ul>
      </li>

      <li class="c-sidebar-nav-dropdown" v-bind:class="[sertifikasiNew ? 'c-show' : '']" v-show="cekRole('ROLE_MENU_SERTIFIKASI')">
        <a class="c-sidebar-nav-dropdown-toggle c-brand-minimizer" @click="toggleSertifikasiNew">
          <i class="c-sidebar-nav-icon fas fa-file-alt"></i>
          {{ this.$string.sidebar.menu_9.text }}
        </a>
        
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_MASTER_SERTIFIKASI')">
            <a
              href="#/sertifikasi-new/master-sertifikasi"
              class="c-sidebar-nav-link"
              target="_self">
            {{ this.$string.sidebar.menu_9.sub_menu.menu_1 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item">
            <a
              href="#/sertifikasi-new/data-peserta-level"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_9.sub_menu.menu_8 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_DATA_PESERTA_SERTIFIKASI')">
            <a
              href="#/sertifikasi-new/data-peserta"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_9.sub_menu.menu_2 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item">
            <a
              href="#/sertifikasi-new/data-peserta-rpl"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_9.sub_menu.menu_7 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PENGAJUAN_SERTIFIKASI')">
            <a
              href="#/sertifikasi/pengajuan-sertifikat"
              class="c-sidebar-nav-link"
              target="_self"
            >
            {{ this.$string.sidebar.menu_9.sub_menu.menu_3 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item">
            <a
              
              href="#/sertifikasi/pengajuan-ujian"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_9.sub_menu.menu_4 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item">
            <a
              
              href="#/sertifikasi/pengajuan-dasar"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_9.sub_menu.menu_5 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item">
            <a
              
              href="#/sertifikasi/pengajuan-Professional"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_9.sub_menu.menu_6 }}
            </a>
          </li>
        </ul>
      </li>

      <li class="c-sidebar-nav-dropdown" v-bind:class="[rpl ? 'c-show' : '']" v-show="cekRole('ROLE_MENU_RPL')">
        <a class="c-sidebar-nav-dropdown-toggle c-brand-minimizer" @click="toggleRpl">
          <i class="c-sidebar-nav-icon fas fa-file-alt"></i>
          RPL
        </a>
        
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_MASTER_RPL')">
            <a
              href="#/rpl/master-rpl"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_3.sub_menu.menu_3 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_DATA_PESERTA_RPL')">
            <a
              href="#/rpl/data-peserta"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_3.sub_menu.menu_5 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PENGAJUAN_SERTIFIKAT_RPL')">
            <a
              href="#/rpl/pengajuan-sertifikat-rpl"
              class="c-sidebar-nav-link"
              target="_self"
            >
            {{ this.$string.sidebar.menu_3.sub_menu.menu_6 }}
            </a>
          </li>          
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_WAIVER')">
            <a
              href="#/rpl/list-waiver"

              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_3.sub_menu.menu_7 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_RIWAYAT_PESERTA_RPL')">
            <a
              href="#/rpl/riwayat-peserta"

              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_3.sub_menu.menu_8 }}
            </a>
          </li>
        </ul>
      </li>
      <li class="c-sidebar-nav-dropdown" v-bind:class="[pelatihan ? 'c-show' : '']" v-show="cekRole('ROLE_MENU_PELATIHAN')">
        <a class="c-sidebar-nav-dropdown-toggle c-brand-minimizer" @click="togglePelatihan">
          <i class="c-sidebar-nav-icon fa fa-users"></i>
          {{ this.$string.sidebar.menu_5.text }}
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <!-- Kode Pelatihan -->
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_KODE_PELATIHAN')">
            <a
              href="#/pelatihan/kode-pelatihan"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_5.sub_menu.menu_11 }}
            </a>
          </li>
          <!-- Daftar Pelatihan -->
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_DAFTAR_PELATIHAN')">
            <a
              href="#/pelatihan/daftar-pelatihan/webinar"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_5.sub_menu.menu_12 }}
            </a>
          </li>
          <!-- menu_12 -->
          <!-- data peserta -->
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_DATA_PESERTA_PELATIHAN')">
            <a
              href="#/pelatihan/data-peserta-pelatihan/Webinar"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_5.sub_menu.menu_6 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_DATA_SKP_PESERTA')">
            <a
              href="#/pelatihan/data-skp-peserta"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_5.sub_menu.menu_14 }}
            </a>
          </li>
          <!-- data pengajuan skp -->
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_DATA_PENGAJUAN_SKP')">
            <a
              href="#/pelatihan/data-pengajuan-skp/terstruktur"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_5.sub_menu.menu_7 }}
            </a>
          </li>
          <!-- data pelaporan skp -->
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_DATA_PELAPORAN_SKP')">
            <a
              href="#/pelatihan/pelaporan-skp"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_4.sub_menu.menu_4 }}
            </a>
          </li>
          <!-- penyelenggara -->
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PENYELENGGARA')">
            <a
              href="#/pelatihan/penyelenggara"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_5.sub_menu.menu_1 }}
            </a>
          </li>
          <!-- instruktur -->
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_INSTRUKTUR')">
            <a
              href="#/pelatihan/instruktur"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_5.sub_menu.menu_2 }}
            </a>
          </li>
          <!-- mitra pelatihan -->
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_MITRA_PELATIHAN')">
            <a
              href="#/pelatihan/mitra-pelatihan"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_5.sub_menu.menu_3 }}
            </a>
          </li>
          <!-- katalog -->
          <li class="c-sidebar-nav-item" style="display: none">
            <a 
              href="#/pelatihan/katalog" 
              class="c-sidebar-nav-link" 
              target="_self">
              {{ this.$string.sidebar.menu_5.sub_menu.menu_4 }}
            </a>
          </li>

          <!-- signature -->
          <!-- <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_SIGNATURE')">
            <a 
              href="#/pelatihan/tanda-tangan" 
              class="c-sidebar-nav-link" 
              target="_self">
              {{ this.$string.sidebar.menu_5.sub_menu.menu_9 }}
            </a>
          </li> -->
         
        </ul>
      </li>
      <li class="c-sidebar-nav-dropdown" v-bind:class="[keanggotaan ? 'c-show' : '']" v-show="cekRole('ROLE_MENU_KEANGGOTAAN')">
        <a class="c-sidebar-nav-dropdown-toggle c-brand-minimizer" @click="toggleKeanggotaan">
          <i class="c-sidebar-nav-icon fa fa-users" aria-hidden="true"></i>
          {{ this.$string.sidebar.menu_4.text }}
        </a>
        <ul class="c-sidebar-nav-dropdown-items" >
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_KATEGORI_ANGGOTA')">
            <a href="#/keanggotaan/kategori-anggota" class="c-sidebar-nav-link" target="_self">
              <i class="c-sidebar-nav-icon cil-speedometer"></i>
              {{ this.$string.sidebar.menu_4.sub_menu.menu_1 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_DATA_ANGGOTA')">
            <a
              href="#/keanggotaan/data-anggota/unverified"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_4.sub_menu.menu_2 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_KAP')">
            <a
              href="#/keanggotaan/kap"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_4.sub_menu.menu_3 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PELAPORAN_SKP')">
            <a
              href="#/keanggotaan/pelaporan-skp"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_4.sub_menu.menu_4 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PENGAJUAN_REKOMENDASI')">
            <a
              href="#/keanggotaan/pengajuan-rekomendasi/unverified"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_4.sub_menu.menu_5 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_ASEAN_CPA')">
            <a 
            href="#/keanggotaan/asean-cpa" 
            class="c-sidebar-nav-link" 
            target="_self">
              {{ this.$string.sidebar.menu_4.sub_menu.menu_6 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_GENERATE_ANNUAL_INVOICE')">
            <a
              href="#/keanggotaan/pengaturan-iuran"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_4.sub_menu.menu_7 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_ANGGOTA_UMUM')">
            <a
              href="#/keanggotaan/anggota-umum"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_4.sub_menu.menu_8 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_SANKSI_ANGGOTA')">
            <a
              href="#/keanggotaan/sanksi-anggota"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_4.sub_menu.menu_9 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_STATISTIK')">
            <a
              
              href="#/keanggotaan/statistik"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_4.sub_menu.menu_10 }}
            </a>
          </li>
        </ul>
      </li>
      <li class="c-sidebar-nav-dropdown" v-bind:class="[finance ? 'c-show' : '']" v-show="cekRole('ROLE_MENU_FINANCE')">
        <a class="c-sidebar-nav-dropdown-toggle c-brand-minimizer" @click="toggleFinance">
          <i class="c-sidebar-nav-icon fas fa-wallet"></i>
          {{ this.$string.sidebar.menu_6.text }}
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PAYMENT')">
            <a href="#/keuangan/pembayaran" class="c-sidebar-nav-link" target="_self">{{ this.$string.sidebar.menu_6.sub_menu.menu_2 }}</a>
          </li>
        </ul>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item" v-show="cekRole('ROLE_PERMINTAAN_PEMBATALAN')">
            <a href="#/keuangan/permintaan-pembatalan" class="c-sidebar-nav-link" target="_self">{{ this.$string.sidebar.menu_6.sub_menu.menu_4 }}</a>
          </li>
        </ul>
      </li>
      <li class="c-sidebar-nav-dropdown" v-bind:class="[broadcast ? 'c-show' : '']" v-show="cekRole('ROLE_MENU_BROADCAST')">
        <a class="c-sidebar-nav-dropdown-toggle c-brand-minimizer" @click="toggleBroadcast">
          <i class="c-sidebar-nav-icon fas fa-bullhorn"></i>
          {{ this.$string.sidebar.menu_7.text }}
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item"  v-show="cekRole('ROLE_EMAIL_BROADCAST')">
            <a href="#/broadcast-email" class="c-sidebar-nav-link" target="_self">
              <i class="c-sidebar-nav-icon cil-speedometer"></i>
              {{ this.$string.sidebar.menu_7.sub_menu.menu_1 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item"  v-show="cekRole('ROLE_BROADCAST_APLIKASI')"> 
            <a
              href="#/broadcast-pesan-aplikasi"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_7.sub_menu.menu_2 }}
            </a>
          </li>
          
        </ul>
      </li>
      <li class="c-sidebar-nav-dropdown" v-bind:class="[log ? 'c-show' : '']" > 
        <!-- v-show="cekRole('ROLE_MENU_BROADCAST')" -->
        <a class="c-sidebar-nav-dropdown-toggle c-brand-minimizer" @click="toggleLog">
          <i class="c-sidebar-nav-icon fas fa-bullhorn"></i>
          {{ this.$string.sidebar.menu_8.text }}
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item"  >
            <!-- v-show="cekRole('ROLE_EMAIL_BROADCAST')" -->
            <a href="#/log-activity" class="c-sidebar-nav-link" target="_self">
              <i class="c-sidebar-nav-icon cil-speedometer"></i>
              {{ this.$string.sidebar.menu_8.sub_menu.menu_1 }}
            </a>
          </li>
          <li class="c-sidebar-nav-item" >
            <!-- v-show="cekRole('ROLE_BROADCAST_APLIKASI')"  -->
            <a
              href="#/log-keanggotaan"
              class="c-sidebar-nav-link"
              target="_self"
            >
              {{ this.$string.sidebar.menu_8.sub_menu.menu_2 }}
            </a>
          </li>
          
        </ul>
      </li>     
    </ul>    
  </CSidebar>
</template>

<script>
import nav from "./_nav";

export default {
  name: "TheSidebar",
  nav,
  data() {
    return {
      user :{},
      datamaster: false,
      usermanajemen: false,
      sertifikasi: false,
      rpl: false,
      keanggotaan: false,
      pelatihan: false,
      finance: false,
      broadcast: false,
      workshop: false,
      log: false,
      sertifikasiNew:false
    };
  },
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    }
  },
  mounted() {
    // alert(this.cekRole("ROLE_ARTIKEL"))

  },
  methods: {
    cekRole(roleName) {
      var user = JSON.parse(localStorage.getItem('user'));
      if(user.singleData == {}) {
        return false;
      }

      if(user.singleData.detail_user.roles == null) {
        return false
      }  
      
      var data = user.singleData.detail_user.roles.find(el => el.nama_role === roleName );
      if(data == undefined || data == 'undefined') {
        return false;
      } else {
        if(roleName == 'ROLE_LOG') {
          if(data.status_read == true) {
            return true
          } else {
            return false
          }
        } else {
          if(data.status_update ==false &&
            data.status_read == false &&
            data.status_create == false &&
            data.status_delete == false ) {
              return false
          } else {
  
            return true;
          }
        }
      }
    },
    toggleDatamaster() {
      this.datamaster = !this.datamaster;
    },
    toggleUserManajemen() {
      this.usermanajemen = !this.usermanajemen;
    },
    toggleSertifikasi() {
      this.sertifikasi = !this.sertifikasi;
    },
    toggleSertifikasiNew() {
      this.sertifikasiNew = !this.sertifikasiNew;
    },
    toggleRpl() {
      this.rpl = !this.rpl;
    },
    toggleKeanggotaan() {
      this.keanggotaan = !this.keanggotaan;
    },
    togglePelatihan() {
      this.pelatihan = !this.pelatihan;
    },
    toggleWorkshop() {
      this.workshop = !this.workshop;
    },
    toggleFinance() {
      this.finance = !this.finance;
    },
    toggleBroadcast() {
      this.broadcast = !this.broadcast;
    },
    toggleLog() {
      this.log = !this.log;
    }
  }
};
</script>
